/**
 * Sitenin tüm Türkçe metni. Kaynak: zhesap-fe/components/landing/*.
 * Bileşenler metin barındırmaz, buradan okur.
 */

export const brand = {
  name: 'ZHesap',
  // Uygulamanın giriş adresi; navbar'daki "Giriş Yap" buraya gider.
  appUrl: 'https://app.zhesap.com/',
  email: 'info@zhesap.com',
  address: 'Dijital Park Teknokent',
  addressDetail:
    'Kirazlıdere Mah. Eski Ankara Cad. A-1 Blok No:4A İç Kapı No:3, Çekmeköy / İstanbul',
  // Görünen numara yerel biçimde; `tel:` bağlantısı uluslararası biçimde.
  phone: '0540 106 15 00',
  phoneHref: 'tel:+905401061500',
  tagline: 'E-ticaret yapan işletmeler için finansal kontrol, kârlılık ve karar platformu.',
} as const;

/**
 * WhatsApp hattı: Z'eki hapında ve panel üst çubuğunda (`components/assistant/AssistantDock`). `wa.me` adresi
 * ülke kodlu, "+" ve boşluksuz numara ister. İletişim telefonundan (`brand.phone`) farklı bir hattır.
 */
export const whatsapp = {
  number: '+90 540 406 14 00',
  href: 'https://wa.me/905404061400',
  label: 'WhatsApp ile yaz',
} as const;

// Yüzen düğmelerin etiketleri: başa dön (`components/ui/FloatingActions`) ve arama (Z'eki hapı). WhatsApp etiketi yukarıdaki
// `whatsapp.label`'dan okunur, tekrar edilmez.
export const floatingActions = {
  scrollTop: { label: 'Başa dön' },
  call: { label: 'Hemen ara' },
} as const;

// nav yapısı dosyanın sonunda, mega menü ile birlikte tanımlanır.

/**
 * Menü, ürün kartları ve ikon kutuları aynı çizgi ikon setini kullanır:
 * 24×24 viewBox'a çizilmiş tek `path` verisi. Remixicon yerine bu set
 * seçildi; tasarımdaki ikonlar ince çizgili ve tek renkli.
 */
export const icons = {
  building: 'M4 21V5l8-3 8 3v16M9 21v-4h6v4M8 9h.01M12 9h.01M16 9h.01M8 13h.01M12 13h.01M16 13h.01',
  team: 'M16 19v-1a4 4 0 00-4-4H7a4 4 0 00-4 4v1M9.5 10a3 3 0 100-6 3 3 0 000 6M21 19v-1a4 4 0 00-3-3.9M16 4.1a3 3 0 010 5.8',
  news: 'M4 5h13v14H6a2 2 0 01-2-2zM17 9h3v8a2 2 0 01-2 2M8 9h5M8 13h5',
  brief: 'M3 8h18v11H3zM8 8V5h8v3M3 13h18',
  hands: 'M12 20l-7-7a3 3 0 014-4l3 3 3-3a3 3 0 014 4z',
  article: 'M6 3h9l4 4v14H6zM9 12h7M9 16h7M9 8h3',
  cart: 'M3 4h2l2.4 11h10.2L20 8H6.2M9 20h.01M17 20h.01',
  stack: 'M12 3l9 5-9 5-9-5zM3 13l9 5 9-5',
  store: 'M4 10v10h16V10M3 6l2-3h14l2 3v2a3 3 0 01-6 0 3 3 0 01-6 0 3 3 0 01-6 0z',
  archive: 'M3 5h18v4H3zM5 9v11h14V9M10 13h4',
  funds: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8M4 21a8 8 0 0116 0',
  line: 'M3 17l6-6 4 4 8-8',
  file: 'M6 3h9l4 4v14H6zM9 11h7M9 15h7',
  mega: 'M3 11v2l12 5V6L3 11zM15 9a3 3 0 010 6M7 13l1 6h3l-1-5',
  radar: 'M12 21a9 9 0 100-18 9 9 0 000 18M12 17a5 5 0 100-10 5 5 0 000 10M12 12l6-6',
  bell: 'M6 8a6 6 0 1112 0c0 7 3 9 3 9H3s3-2 3-9M10 21h4',
  robot: 'M5 8h14v11H5zM12 4v4M9 13h.01M15 13h.01M9 16h6',
  chat: 'M4 5h16v11H9l-5 4zM9 10h.01M12 10h.01M15 10h.01',
  chrome: 'M12 21a9 9 0 100-18 9 9 0 000 18M12 16a4 4 0 100-8 4 4 0 000 8M12 8h8.5M8.5 14L4 6.5M15.5 14L11 21',
  calc: 'M6 3h12v18H6zM9 7h6M9 12h.01M12 12h.01M15 12h.01M9 16h.01M12 16h.01M15 16h.01',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7z',
  percent: 'M19 5L5 19M7.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3M16.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3',
  award: 'M12 15a6 6 0 100-12 6 6 0 000 12M8.5 14L7 22l5-3 5 3-1.5-8',
  clock: 'M12 21a9 9 0 100-18 9 9 0 000 18M12 7v5l3 2',
  history: 'M3 12a9 9 0 109-9 9 9 0 00-7 3.4M3 4v4h4M12 8v4l3 2',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z',
  shieldCheck: 'M12 3L4 6v6c0 4.5 3.4 8.3 8 9 4.6-.7 8-4.5 8-9V6zM9 12l2 2 4-4',
  lock: 'M3 11h18v10H3zM7 11V7a5 5 0 0110 0v4',
  database:
    'M4 5c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6',
  teknokent: 'M3 21h18M5 21V8l7-4 7 4v13M9 21v-5h6v5M9 10h.01M12 10h.01M15 10h.01',
  mail: 'M3 5h18v14H3zM3 7l9 6 9-6',
  phone: 'M5 3h4l2 5-2.5 1.5a11 11 0 006 6L16 13l5 2v4a2 2 0 01-2 2A17 17 0 013 5a2 2 0 012-2',
  pin: 'M12 22s7-6.2 7-12a7 7 0 00-14 0c0 5.8 7 12 7 12zM12 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5',
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  chevronRight: 'M9 6l6 6-6 6',
  chevronDown: 'M6 9l6 6 6-6',
  expand: 'M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7',
  close: 'M6 6l12 12M18 6L6 18',
  check: 'M5 12l5 5 9-10',
  menu: 'M4 7h16M4 12h16M4 17h16',
  // Blog ve footer ikonları (2 Kasım: remixicon CDN'i kaldırıldı, hepsi bu sette).
  arrowLeft: 'M19 12H5M12 19l-7-7 7-7',
  arrowUpRight: 'M7 17L17 7M8 7h9v9',
  search: 'M11 4a7 7 0 100 14 7 7 0 000-14zM20 20l-4-4',
  refresh: 'M3 12a9 9 0 0115.5-6.3L21 8M21 3v5h-5M21 12a9 9 0 01-15.5 6.3L3 16M3 21v-5h5',
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  bookOpen: 'M2 4h6a4 4 0 014 4v12a3 3 0 00-3-3H2zM22 4h-6a4 4 0 00-4 4v12a3 3 0 013-3h7z',
  link: 'M10 13a5 5 0 007.5.5l3-3a5 5 0 00-7-7l-1.5 1.5M14 11a5 5 0 00-7.5-.5l-3 3a5 5 0 007 7l1.5-1.5',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7zM12 9a3 3 0 100 6 3 3 0 000-6z',
  // Sosyal ağ işaretleri, aynı çizgi dilinde.
  instagram: 'M7 3h10a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4zM12 8.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM17.5 6.5h.01',
  facebook: 'M14 3h3v4h-3a1 1 0 00-1 1v3h4l-.5 4H13v7H9v-7H6v-4h3V8a5 5 0 015-5z',
  linkedin: 'M4 9h4v12H4zM6 3a2 2 0 110 4 2 2 0 010-4M10 9h4v2a4 4 0 014-2 4 4 0 014 4v8h-4v-7a2 2 0 00-4 0v7h-4z',
  x: 'M4 4l11.5 16H20L8.5 4zM20 4l-6.6 7.6M4 20l6.6-7.6',
  youtube: 'M3 12c0-3 .3-4.5.8-5.3a2.6 2.6 0 011.9-1.2C7.5 5.2 12 5.2 12 5.2s4.5 0 6.3.3a2.6 2.6 0 011.9 1.2c.5.8.8 2.3.8 5.3s-.3 4.5-.8 5.3a2.6 2.6 0 01-1.9 1.2c-1.8.3-6.3.3-6.3.3s-4.5 0-6.3-.3a2.6 2.6 0 01-1.9-1.2C3.3 16.5 3 15 3 12zM10 9.5v5l4.5-2.5z',
} as const;

export type IconName = keyof typeof icons;

/**
 * Kurucu metinleri. `lead` katlanmadan görünür, `rest` "Devamını oku" ile
 * açılır — wireframe'deki "Devamı..." davranışı.
 *
 * Paragrafların bir kısmı kaynak metinde kalın: `strong` işaretli olanlar
 * kurucunun altını çizdiği cümleler, düz metinden ayrılarak çiziliyor.
 *
 * Kurucular admin panelinden yönetilir (`useFounders()`; fotoğraf da oradan).
 * Buradaki metin CMS'e ulaşılamadığında kullanılan yedektir; başlıklar
 * (eyebrow, title, readMoreLabel) koddan okunur.
 */
export interface FounderParagraph {
  text: string;
  strong?: boolean;
}

export const founders = {
  eyebrow: 'Kurucularımızdan',
  title: 'ZHesap nedir?',
  readMoreLabel: 'Devamını oku',
  // Kurucu yazı sayfasının sabit metinleri (sayfanın üst etiketi `eyebrow`).
  page: {
    readingTime: (min: number) => `${min} dk okuma`,
  },
  // Kurucu yazısının açıldığı pencerenin metinleri.
  modal: {
    close: 'Kapat',
  },
  people: [
    {
      slug: 'orkun-kurt',
      name: 'Orkun Kurt',
      role: 'Co-Founder, CEO',
      lead: [
        { text: "15 yıldır e-ticaret yapıyorum. Binlerce ürün sattım, milyonlarca sipariş yönettim. Pazaryerlerinde kampanyalara girdim, reklam verdim, fiyat değiştirdim, stok yönettim, ekipler kurdum." },
        { text: "Ama yıllar boyunca aynı gerçekle karşılaştım:" },
        { text: "E-ticarette satış yapmak zor değil. Zor olan, o satıştan gerçekten para kazanıp kazanmadığını bilmektir.", strong: true },
      ],
      rest: [
        { text: "Çünkü bir siparişin arkasında yalnızca ürün maliyeti yok. Komisyon var. Kargo var. Reklam var. Kampanya var. İade var. Hizmet bedelleri var. Ödeme vadeleri var. Sürekli değişen fiyatlar ve rakipler var." },
        { text: "Ve bütün bunlar olurken sizden her gün onlarca karar vermeniz bekleniyor." },
        { text: "Hangi üründe gerçekten para kazanıyorum? Hangi kampanyaya girmeliyim? Hangi üründe fiyatım yanlış? Rakibim ne yaptı? Stokta neyi kaçırıyorum? Ve en önemlisi: Sattım ama gerçekten para kazandım mı?", strong: true },
        { text: "Ben bu soruların cevabını 15 yıl boyunca kendim aradım. Excel’lerle, raporlarla, ekiplerle, farklı sistemlerden topladığım verilerle…" },
        { text: "Sonra şunu fark ettim:" },
        { text: "Benim ihtiyacım daha fazla veri değildi. Benim ihtiyacım, ne yapmam gerektiğini söyleyen bir sistemdi.", strong: true },
        { text: "ZHesap tam olarak bu yüzden var." },
        { text: "ERP’nizdeki maliyeti, pazaryerlerindeki siparişi, e-ticaret sitenizdeki satışı, reklamı, kampanyayı, stoğu, fiyatı ve rakibi birbirinden bağımsız rakamlar olarak görmek için değil;" },
        { text: "hepsini tek bir ticari karara dönüştürmek için.", strong: true },
        { text: "Çünkü ben bir e-ticaretçinin sabah bilgisayarını açtığında 14 ayrı rapora bakmasını istemiyorum. Şunu görmesini istiyorum:" },
        { text: "Burada para kazanıyorsun. Burada kaybediyorsun. Burada fırsat var. Burada aksiyon almalısın.", strong: true },
        { text: "15 yıl boyunca bunu kendim yapmak zorunda kaldım." },
        { text: "Şimdi ZHesap yapıyor.", strong: true },
      ],
    },
    {
      slug: 'ibrahim-buluter',
      name: 'İbrahim Buluter',
      role: 'Co-Founder, CTO',
      // Ana sayfa kartı `lead`'in kısaltılmış hâlini gösterir; kurucu
      // sayfası tam metni okur.
      teaser: [
        { text: "2009’dan beri yazılım geliştiriyorum. Saha satış uygulamalarından ön muhasebe sistemlerine, mobil uygulamalardan e-ticaret ara yazılımlarına kadar yüzlerce farklı ihtiyacın içinde bulundum." },
        { text: "2010’dan itibaren e-ticaretin tam merkezindeyim. Orkun’la birlikte bir markayı sektörünün lideri hâline getirdik; ardından kendi markamı sıfırdan kurup büyüttüm. 100’ün üzerinde marka ve firmayla e-ticaret ve teknoloji tarafında çalıştım." },
      ],
      lead: [
        { text: "2009’dan beri yazılım geliştiriyorum." },
        { text: "Saha satış uygulamalarından ön muhasebe sistemlerine, mobil uygulamalardan e-ticaret ara yazılımlarına, entegrasyonlardan farklı sektörlere özel otomasyonlara kadar yüzlerce farklı ihtiyacın içinde bulundum." },
        { text: "2010’dan itibaren ise e-ticaretin de tam merkezinde yer aldım. Orkun’la beraber 7 yıl boyunca tek bir markayı sektörünün lideri hâline getirdik. Sonra kendi projem olan bir markayı sıfırdan kurup, kendi e-ticaret sitesi ve pazaryerleriyle birlikte 5 yıl yönettim ve sonunda satışını gerçekleştirdim. Bunun yanında 100’ün üzerinde marka ve firmayla e-ticaret ve teknoloji tarafında çalışma fırsatım oldu." },
      ],
      rest: [
        { text: "Yıllar içinde farklı şirketleri, farklı sektörleri ve farklı ülkeleri gördüm. Ve hepsinde tekrar tekrar karşıma çıkan bir problem vardı:" },
        { text: "Şirketler veri üretiyordu ama veriyi gerçekten yönetemiyordu.", strong: true },
        { text: "Excel dosyaları büyüyordu. Raporlar çoğalıyordu. Farklı sistemlerden veriler toplanıyor, birbirleriyle karşılaştırılıyor, hesaplamalar yapılıyordu." },
        { text: "Ama çoğu zaman bütün bu çalışmaların sonunda hâlâ şu soru soruluyordu:" },
        { text: "“Peki şimdi ne yapacağız?”", strong: true },
        { text: "Bir başka problemi ise özellikle şirketler büyüdükçe gördüm. Ciro yükseliyordu ama operasyon da aynı hızla şişiyordu. Sipariş sayısı artıyor, stok büyüyor, kargo maliyetleri yükseliyor, ekipler genişliyor, reklam harcamaları artıyor ve şirket sahipleri daha fazla ciroyu daha fazla kazanç zannetmeye başlayabiliyordu." },
        { text: "Oysa bazen şirket büyümüyor, sadece daha karmaşık hâle geliyordu." },
        { text: "Çünkü yüksek ciro, kontrol edilemeyen bir operasyonla birleştiğinde büyüme değil, risk yaratır.", strong: true },
        { text: "Ben yıllarca bu problemlerin çözümü için yazılımlar geliştirdim. Ama zamanla şunu fark ettim:" },
        { text: "Şirketlerin ihtiyacı sadece daha fazla yazılım değildi. İhtiyaçları, sahip oldukları tüm veriyi anlayabilen bir sistemdi.", strong: true },
        { text: "2020 yılında kafamda bir “Boss Screen” fikri vardı. Yöneticinin bilgisayarını açtığında şirketinin durumunu tek ekranda görebileceği bir yapı…" },
        { text: "Fakat yıllar içinde bunun tek başına yeterli olmadığını gördüm. Çünkü yöneticinin yalnızca sonucu görmesi yetmiyordu." },
        { text: "Neden olduğunu da bilmesi gerekiyordu.", strong: true },
        { text: "Kâr düştüyse neden düştü? Hangi ürün kâr kaybettiriyor? Hangi kampanya aslında zarar ettiriyor? Hangi maliyet kontrolden çıkıyor? Hangi stok sermayeyi bağlıyor? Hangi operasyon büyümeyi engelliyor?" },
        { text: "Ve daha önemlisi:" },
        { text: "Bunları yöneticinin her gün kendisinin bulması neden gerekiyor?", strong: true },
        { text: "Almanya’da ve farklı Avrupa ülkelerinde faaliyet gösteren e-ticaret şirketleriyle çalışırken bu ihtiyacı daha yakından gözlemleme fırsatım oldu. İsviçre’den Hollanda’ya farklı firmalar için otomasyonlar ve ara sistemler geliştirdik." },
        { text: "Ülkeler, şirketler ve iş modelleri değişiyordu. Ama ihtiyaç aynıydı:" },
        { text: "Veriyi hızlı anlamak. Problemi zamanında görmek. Doğru kararı gecikmeden almak.", strong: true },
        { text: "ZHesap’ı bu yüzden yalnızca bir raporlama platformu olarak görmüyorum. Benim için ZHesap’ın ulaşması gereken nokta, şirketin sürekli çalışan ticari zekâsı ve otomasyonu olması." },
        { text: "Şirketinizi bir kez kurup verilerinizi bağladığınızda ZHesap’ın şirketinizi sürekli analiz ettiğini düşünün. Nerede hata yaptığınızı buluyor. Nerede kâr kaybettiğinizi gösteriyor. Gözden kaçan maliyetleri tespit ediyor. Operasyondaki riskleri önceden fark ediyor. Kârlılığı artırabileceğiniz fırsatları ortaya çıkarıyor." },
        { text: "Ve en önemlisi, bunları yalnızca siz rapor istediğinizde değil, sürekli olarak yapıyor.", strong: true },
        { text: "Benim ZHesap vizyonum tam olarak bu." },
        { text: "One Click Setup. Verilerinizi bağlayın. ZHesap şirketinizi anlasın.", strong: true },
        { text: "Size yalnızca ne olduğunu söylemesin." },
        { text: "Neden olduğunu bulsun. Ne yapmanız gerektiğini söylesin. Ve siz harekete geçene kadar sizi uyarsın.", strong: true },
        { text: "Çünkü geleceğin ticaret yazılımının görevi yöneticiyi daha fazla rapora boğmak değil; yöneticinin karar verme yükünü azaltmak." },
        { text: "Yıllardır şirketlerin teknolojisini geliştiriyorum. Şimdi yapmak istediğim şey, teknolojinin şirketi takip ettiği değil; şirketin önünden gidip ona yol gösterdiği bir sistem kurmak." },
        { text: "ZHesap benim için bir raporlama yazılımı değil. Kendi kendini sürekli analiz eden, sorunları bulan, fırsatları gösteren ve şirketi daha iyi kararlara yönlendiren bir ticaret otomasyonu.", strong: true },
      ],
    },
  ],
} as const;

/**
 * Ana sayfadaki demo formu (`#erken-erisim`). Çapa adı eski "Erken Erişim"
 * bölümünden kaldı; dış bağlantılar ve menü bu adrese gittiği için korunuyor.
 */
export const cta = {
  eyebrow: 'Demo',
  title: 'ZHesap ile hemen',
  titleAccent: 'tanış.',
  description:
    'Bilgilerini bırak, uzman ekibimiz seni arasın; ZHesap’ı kendi mağaza verilerinle birlikte inceleyelim.',
  badges: [
    { icon: 'award', label: '15+ Yıllık Tecrübe' },
    { icon: 'clock', label: '15 Dakikada Kurulum' },
    { icon: 'history', label: 'Geçmişe Dönük Analiz' },
    { icon: 'shield', label: 'KVKK Uyumlu Altyapı' },
  ] as { icon: IconName; label: string }[],
  form: {
    name: 'Ad Soyad',
    namePlaceholder: 'Adınız Soyadınız',
    email: 'E-posta',
    emailPlaceholder: 'ornek@sirket.com',
    phone: 'Telefon',
    phonePlaceholder: '0532 123 45 67',
    submit: '7 Gün Ücretsiz Dene',
    submitting: 'Gönderiliyor…',
    success: 'Teşekkürler! Uzman ekibimiz seni arayacak.',
    error: 'Bir hata oluştu. Lütfen tekrar deneyin.',
  },
  contactHint: 'Sorularınız için',
} as const;

/**
 * Site bilgi mimarisi (ClickUp 86cbaz1t6 — ZHesap-Menu.xlsx).
 *
 * Bağlantı hedefleri kalıcı slug'lardır; sayfalar henüz açılmadığı için
 * bugün 404'e düşerler. Route eklendikçe burada değişiklik gerekmez.
 */
export const routes = {
  kurumsal: {
    root: '/kurumsal',
    bizKimiz: '/kurumsal/biz-kimiz',
    ekibimiz: '/kurumsal/ekibimiz',
    haberler: '/kurumsal/bizden-haberler',
    kariyer: '/kurumsal/kariyer',
    // Metin dosyası adresi kurumsal altına koymuyor; sayfa kökte duruyor.
    partnerlik: '/partnerlik',
    isOrtaklari: '/kurumsal/is-ortaklarimiz',
    nelerVar: '/kurumsal/zhesapta-neler-var',
    kurucular: '/kurumsal/kurucularimizdan',
  },
  cozumler: {
    root: '/cozumler',
    // Satış kanalına göre
    pazaryeri: '/cozumler/pazaryeri',
    eticaret: '/cozumler/e-ticaret-sitesi',
    cokluMarka: '/cozumler/coklu-marka',
    omnichannel: '/cozumler/omnichannel',
    // İhtiyaca göre
    kampanya: '/cozumler/kampanya-karliligi',
    karlilik: '/cozumler/karlilik',
    kayip: '/cozumler/finansal-kayiplar',
    stok: '/cozumler/stok-yonetimi',
    rakip: '/cozumler/rakip-takibi',
  },
  ozellikler: {
    root: '/ozellikler',
    karlilik: '/ozellikler/karlilik-analizi',
    kargo: '/ozellikler/kargo-analizi',
    hakedis: '/ozellikler/mutabakat-hakedis',
    kampanya: '/ozellikler/kampanya-yonetimi',
    stok: '/ozellikler/akilli-stok-optimizasyonu',
    rekabet: '/ozellikler/rekabet-sektor-analizi',
    nakit: '/ozellikler/nakit-akisi',
    buybox: '/ozellikler/buybox-takibi',
    raporlama: '/ozellikler/ozel-raporlama',
    uyari: '/ozellikler/uyari-otomasyonu',
    whatsapp: '/ozellikler/whatsapp-pazarlama',
    zeki: '/ozellikler/zeki-sirket-asistani',
    yorum: '/ozellikler/urun-yorum-analizi',
    crm: '/ozellikler/musteri-iliskileri-yonetimi',
  },
  araclar: {
    root: '/araclar',
    chrome: '/araclar/google-chrome-eklentisi',
    fiyat: '/araclar/fiyat-hesaplama',
    magaza: '/araclar/magaza-analizi',
  },
  yasal: {
    root: '/yasal',
    cerez: '/yasal/cerez-politikasi',
    gizlilik: '/yasal/gizlilik-politikasi',
    kullanim: '/yasal/kullanim-sartlari',
    kvkk: '/yasal/kvkk',
    guvenlik: '/yasal/veri-guvenligi',
    mesafeli: '/yasal/mesafeli-satis-ve-abonelik-sozlesmesi',
    onBilgilendirme: '/yasal/on-bilgilendirme-formu',
    iptalIade: '/yasal/iptal-ve-iade-kosullari',
  },
  blog: '/blog',
  sss: '/sss',
  entegrasyonlar: '/entegrasyonlar',
  fiyatlar: '/fiyatlar',
  iletisim: '/iletisim',
} as const;

/**
 * Kurucu yazısının adresi: ana sayfayı `?kurucu=slug` ile açar, yazı orada pencerede (FounderModal) görünür.
 * Eski `/kurumsal/kurucularimizdan/:slug` adresi yalnız buraya yönlenir (`pages/founder/redirect.tsx`).
 */
export function founderPath(slug: string) {
  return `/?kurucu=${slug}`;
}

/** Blog yazısının ve kategori sayfasının adresi (admin panelindeki kısa ad). */
export function blogPostPath(slug: string) {
  return `${routes.blog}/${slug}`;
}

export function blogCategoryPath(slug: string) {
  return `${routes.blog}/kategori/${slug}`;
}

/** Etiketli yazı listesi (`/blog?etiket=…`); etiket sayfası ayrı rota değil, listenin süzgeci. */
export function blogTagPath(tag: string) {
  return `${routes.blog}?etiket=${encodeURIComponent(tag)}`;
}

/**
 * Form onay metinleri. Sitedeki tüm formlar (demo, iletişim, partnerlik,
 * omnichannel) AYNI aydınlatma metnini gösterir; tek kaynakta durur ki
 * ayrışmasınlar.
 *
 * Aydınlatma onayı "okudum ve anladım" biçimindedir: form yanıtlamak için
 * açık rıza gerekmez, aydınlatma yeterlidir ("işlenmesini kabul ediyorum"
 * ifadesi kullanılmaz). Ticari ileti onayı ayrı, isteğe bağlı ve işaretsiz
 * gelir; aydınlatma onayı olmadan form gönderilemez.
 */
export const consent = {
  marketing:
    'Kampanyalar ve gelişmelerden haberdar olabilmek için şahsıma ticari elektronik ileti gönderilmesini kabul ediyorum.',
  privacyBefore: '',
  privacyLink: 'KVKK Aydınlatma Metni',
  privacyAfter: '’ni okudum ve anladım.',
  privacyHref: routes.yasal.kvkk,
  error: 'Devam etmek için onay vermeniz gerekiyor.',
} as const;

export interface FooterLink {
  label: string;
  href: string;
}

export interface FooterColumn {
  title: string;
  links: FooterLink[];
}

export const footer = {
  /** İletişim satırlarının etiketleri; değerler `brand`'den okunur. */
  contact: {
    address: 'Adres',
    phone: 'Telefon',
    email: 'Email',
  },
  columns: [
    {
      title: 'Kurumsal',
      links: [
        { label: 'Biz Kimiz?', href: routes.kurumsal.bizKimiz },
        { label: 'Partnerlik', href: routes.kurumsal.partnerlik },
        { label: 'İletişim', href: routes.iletisim },
      ],
    },
    {
      title: 'Ürünler',
      links: [
        { label: 'Tüm Ürünler', href: routes.ozellikler.root },
        { label: 'Kârlılık Analizi', href: routes.ozellikler.karlilik },
        { label: 'Finans & Mutabakat', href: routes.ozellikler.hakedis },
        { label: 'Kampanya Kârlılığı', href: routes.ozellikler.kampanya },
        { label: 'Rakip & Sektör Analizi', href: routes.ozellikler.rekabet },
        { label: 'Stok Zekâsı', href: routes.ozellikler.stok },
        { label: 'Akıllı Uyarı Sistemi', href: routes.ozellikler.uyari },
        { label: 'Tarayıcı Eklentisi', href: routes.araclar.chrome },
        { label: "Z'eki", href: routes.ozellikler.zeki },
        { label: 'AI Müşteri İlişkileri', href: routes.ozellikler.crm },
      ],
    },
    {
      title: 'Kaynaklar',
      links: [
        { label: 'Fiyatlandırma', href: routes.fiyatlar },
        { label: 'Entegrasyonlar', href: routes.entegrasyonlar },
        { label: 'Blog', href: routes.blog },
        { label: 'SSS', href: routes.sss },
      ],
    },
    {
      title: 'Yasal & Güvenlik',
      links: [
        { label: 'KVKK Aydınlatma Metni', href: routes.yasal.kvkk },
        { label: 'Gizlilik Politikası', href: routes.yasal.gizlilik },
        { label: 'Çerez Politikası', href: routes.yasal.cerez },
        { label: 'Kullanım Şartları', href: routes.yasal.kullanim },
        { label: 'Mesafeli Satış ve Abonelik Sözleşmesi', href: routes.yasal.mesafeli },
        { label: 'Ön Bilgilendirme Formu', href: routes.yasal.onBilgilendirme },
        { label: 'İptal & İade Koşulları', href: routes.yasal.iptalIade },
        { label: 'Veri Güvenliği', href: routes.yasal.guvenlik },
      ],
    },
  ] as FooterColumn[],
  socials: [
    { icon: 'instagram', href: 'https://www.instagram.com/zhesapcom/', label: 'Instagram' },
    { icon: 'facebook', href: 'https://www.facebook.com/zhesap', label: 'Facebook' },
    { icon: 'linkedin', href: 'https://www.linkedin.com/company/zhesap/', label: 'LinkedIn' },
  ],
  copyright: '© 2026 Z Hesap Yazılım A.Ş. Tüm hakları saklıdır.',
  legalHub: { label: 'Yasal Merkez', href: routes.yasal.root },
  trust: [
    { icon: 'teknokent', label: 'Dijital Park Teknokent Firmasıdır' },
    { icon: 'shieldCheck', label: 'KVKK Uyumlu Altyapı' },
    { icon: 'lock', label: 'Güvenli Ödeme' },
    { icon: 'database', label: 'Verileriniz Güvende' },
  ] as { icon: IconName; label: string }[],
} as const;

export interface MenuLink {
  label: string;
  desc?: string;
  icon?: IconName;
  href: string;
  /** Sayfa henüz yayında olmayan ürün; menüde rozetle işaretlenir. */
  soon?: boolean;
  /** Kısa durum rozeti (ör. "Beta"); admin menüsünden gelir, `soon` açıkken gösterilmez. */
  badge?: string;
}

export interface MenuColumn {
  title: string;
  links: MenuLink[];
}

export interface MenuPanel {
  columns: MenuColumn[];
  aside?: {
    title: string;
    desc?: string;
    href: string;
    cta: string;
    /** Bağlantı yerine birincil buton olarak çizilir. */
    button?: boolean;
  };
}

export interface NavItem {
  label: string;
  href: string;
  panel?: MenuPanel;
}

/**
 * Üst menü. Panel taşıyan girişler mega menü açar; taşımayanlar
 * (Entegrasyonlar, Fiyatlandırma) düz bağlantıdır.
 *
 * Ürün sayfaları mevcut `/ozellikler/*` adreslerinde durur; çözüm ve
 * ihtiyaç sayfaları `/cozumler/*` altında yeni açıldı.
 */
// Menü admin panelinden yönetilir (`useMenu()`); burası CMS'e ulaşılamadığında kullanılan yedek ve
// "Çok Yakında" sayfalarının (menuPages) kaynağıdır. Buradaki adresler backend'deki
// SitePageCatalog ile aynı tutulur: admin yalnız o listedeki sayfalara bağlantı verebilir.
const navItems: NavItem[] = [
  {
    label: 'Ürünler',
    href: routes.ozellikler.root,
    panel: {
      // Gruplar "ZHesap Yeni Menü.xlsx" tanımından: Kâr & Finans, Ticari zekâ, Yapay zekâ.
      columns: [
        {
          title: 'Kâr & Finans',
          links: [
            { label: 'Kârlılık Analizi', desc: 'Gerçek net kârını siparişten ürüne kadar gör', icon: 'line', href: routes.ozellikler.karlilik },
            { label: 'Finans & Mutabakat', desc: 'Eksik hakedişleri ve hatalı kargo bedellerini yakala', icon: 'file', href: routes.ozellikler.hakedis },
            { label: 'Kampanya Kârlılığı', desc: 'Kampanyaya girmeden önce ne kazanacağını hesapla', icon: 'mega', href: routes.ozellikler.kampanya },
            { label: 'Tarayıcı Eklentisi', desc: 'Pazaryeri panelinden çıkmadan gerçek kârını gör', icon: 'chrome', href: routes.araclar.chrome },
          ],
        },
        {
          title: 'Ticari zekâ',
          links: [
            { label: 'Rakip & Sektör Analizi', desc: 'Rakip fiyat, stok, kampanya ve BuyBox hareketlerini izle', icon: 'radar', href: routes.ozellikler.rekabet },
            { label: 'Stok Zekâsı', desc: 'Kritik, hareketsiz ve tükenmek üzere olan ürünleri bul', icon: 'archive', href: routes.ozellikler.stok },
            { label: 'Akıllı Uyarı Sistemi', desc: 'Kârını etkileyen her gelişmeyi büyümeden yakala', icon: 'bell', href: routes.ozellikler.uyari },
          ],
        },
        {
          title: 'Yapay zekâ',
          links: [
            { label: "Z'eki", desc: 'Verilerini analiz et, doğru aksiyonu Z’eki’ye sor', icon: 'robot', href: routes.ozellikler.zeki, badge: 'Beta' },
            { label: 'AI Müşteri İlişkileri', desc: 'Müşteri sorularını yapay zekâyla yanıtla', icon: 'user', href: routes.ozellikler.crm },
          ],
        },
      ],
      aside: {
        title: 'Tek tıkla tüm e-ticaret bilinmezlerini anlamlandırın!',
        // Tüm Ürünler sayfasının menüdeki tek girişi: "Ürünler" başlığı paneli açar, sayfaya götürmez.
        href: routes.ozellikler.root,
        cta: 'Tüm Ürünler',
        button: true,
      },
    },
  },
  {
    label: 'Çözümler',
    href: routes.cozumler.root,
    panel: {
      columns: [
        {
          title: 'Satış kanalına göre',
          links: [
            { label: 'Pazaryerinde Satış Yapıyorum', desc: 'Tüm pazaryeri operasyonunu tek merkezden yönet', icon: 'cart', href: routes.cozumler.pazaryeri },
            { label: 'Kendi E-ticaret Sitemden Satıyorum', desc: 'Satış, maliyet ve kârlılığını tek yerde birleştir', icon: 'store', href: routes.cozumler.eticaret },
            { label: 'Birden Fazla Marka / Mağaza Yönetiyorum', desc: 'Tüm mağazalarını konsolide olarak takip et', icon: 'stack', href: routes.cozumler.cokluMarka },
            { label: 'Omnichannel Satış Yapıyorum', desc: 'Mağaza, e-ticaret ve pazaryeri tek tabloda', icon: 'brief', href: routes.cozumler.omnichannel, soon: true },
          ],
        },
        {
          title: 'İhtiyaca göre',
          links: [
            { label: 'Kampanyalarımı Kârlı Yönetmek İstiyorum', desc: 'Kampanyaya girmeden önce cebinde ne kalacağını gör', icon: 'mega', href: routes.cozumler.kampanya },
            { label: 'Kârlılığımı Artırmak İstiyorum', desc: 'Nerede kazanıp nerede kaybettiğini gör', icon: 'line', href: routes.cozumler.karlilik },
            { label: 'Finansal Kayıplarımı Bulmak İstiyorum', desc: 'Eksik hakedişleri ve hatalı kesintileri yakala', icon: 'file', href: routes.cozumler.kayip },
            { label: 'Stoklarımı Doğru Yönetmek İstiyorum', desc: 'Paran hangi üründe bekliyor, hangisi tükeniyor gör', icon: 'archive', href: routes.cozumler.stok },
            { label: 'Rakiplerimi Takip Etmek İstiyorum', desc: 'Fiyat, stok, kampanya ve BuyBox hareketlerini izle', icon: 'radar', href: routes.cozumler.rakip },
          ],
        },
      ],
      aside: {
        title: 'AI Müşteri İlişkileri Yönetim Sistemi',
        desc: 'Gelen mesajı, yorumu ve iade talebini tek gelen kutusunda toplar; yapay zekâ önerdiği yanıtla birlikte sunar.',
        href: routes.ozellikler.crm,
        cta: 'Sistemi inceleyin',
      },
    },
  },
  { label: 'Entegrasyonlar', href: routes.entegrasyonlar },
  { label: 'Fiyatlandırma', href: routes.fiyatlar },
];

export const nav = {
  items: navItems,
  login: { label: 'Giriş Yap', href: brand.appUrl },
  // Çapa kökle yazılır: alt sayfada tek başına '#erken-erisim' bulunduğu
  // adrese çözülüyor ve hiçbir yere gitmiyordu.
  cta: { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' },
};

/**
 * Menüdeki her sayfanın kırılım bilgisi. Liste elle yazılmaz; üst menü ve
 * footer'dan türetilir — bağlantı eklendiğinde sayfası da kendiliğinden
 * doğar, iki yerde güncelleme gerekmez.
 */
export interface MenuPage {
  href: string;
  label: string;
  /** Kırılımdaki ara adım: mega menünün ana başlığı ya da footer sütunu. */
  section?: { label: string; href?: string };
}

function buildMenuPages(): MenuPage[] {
  const pages = new Map<string, MenuPage>();
  // Çapa (#erken-erisim) ve dış adresler sayfa değil.
  const add = (page: MenuPage) => {
    if (!page.href.startsWith('/') || pages.has(page.href)) return;
    pages.set(page.href, page);
  };

  for (const item of navItems) {
    add({ href: item.href, label: item.label });
    const section = { label: item.label, href: item.href };
    for (const column of item.panel?.columns ?? []) {
      for (const link of column.links) add({ href: link.href, label: link.label, section });
    }
    if (item.panel?.aside) {
      add({ href: item.panel.aside.href, label: item.panel.aside.title, section });
    }
  }

  // Yasal başlıklar yalnız footer'da; menüde karşılığı yok.
  for (const column of footer.columns) {
    for (const link of column.links) {
      add({ href: link.href, label: link.label, section: { label: column.title } });
    }
  }
  add({ href: footer.legalHub.href, label: footer.legalHub.label });

  return [...pages.values()];
}

export const menuPages = buildMenuPages();

export const breadcrumbHome = { label: 'Ana Sayfa', href: '/' };

/** İçeriği hazır olmayan menü sayfalarının gövdesi. */
export const comingSoon = {
  eyebrow: 'Çok Yakında',
  title: 'Bu sayfa hazırlanıyor',
  description:
    'İçeriği yayına hazırlıyoruz. Bu arada demo talebinizi bırakabilirsiniz; uzman ekibimiz ZHesap’ı size kendi verilerinizle göstersin.',
  primaryCta: { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' },
  secondaryCta: { label: 'Ana sayfaya dön', href: '/' },
} as const;

/** Ana sayfadaki ürün kartları, detay penceresi ve "Tek panel" modülleri. */
export interface LandingProduct {
  /** Önizleme ekranını seçer (pages/home/components/screens.tsx). */
  id: 'karlilik' | 'finans' | 'kampanya' | 'stok' | 'rakip';
  title: string;
  /** Kartın altındaki renkli tek satır. */
  tagline: string;
  description: string;
  /** Kârlılık kartındaki tik listesi; diğer kartlarda yok. */
  checks?: string[];
  href: string;
  /** Kart çizgisi, alt başlık ve ikon rengi (tasarımdaki ürün rengi). */
  accent: string;
  detail: { headline: string; intro: string; bullets: string[] };
}

export const landing = {
  hero: {
    eyebrow: 'E-ticaret kârlılık & finansal karar platformu',
    title: 'Sattım. Ama gerçekten',
    titleAccent: 'para kazandım mı?',
    description:
      'ZHesap kargo faturanı ve pazaryeri hakedişini anlaşmanla sipariş sipariş karşılaştırır, kârlı kampanyalara otomatik katılır, müşteri sorularını yapay zekâyla yanıtlar. Her siparişte cebinde gerçekte ne kaldığını gösterir.',
    primaryCta: { label: '7 Gün Ücretsiz Dene', href: '#erken-erisim' },
    secondaryCta: { label: 'Ürünleri Keşfet', href: '#urunler' },
    // 30 Ekim revizesi: genel rozetler (Hızlı kurulum / Tüm veriler tek yerde / Gerçek kâr görünürlüğü) yerine somut vaatler.
    features: [
      { icon: 'clock', title: '15 Dakikada Kurulum', desc: 'Mağazanı ekibimiz bağlar' },
      { icon: 'history', title: 'Son 3 ay ücretsiz', desc: 'Kargo ve hakediş kontrolü' },
      { icon: 'award', title: '7 gün ücretsiz', desc: 'Kendi verinle dene' },
    ] as { icon: IconName; title: string; desc: string }[],
    /** Laptop ekranının erişilebilir adı; dönen ekranın başlığı eklenir (pages/home/heroScreens.ts). */
    screenLabel: 'ZHesap ekranı',
    screensLabel: 'Laptop ekranını seç',
  },
  strip: {
    eyebrow: 'Entegrasyonlar',
    title: 'Veriyi sen taşıma.',
    titleAccent: 'ZHesap toplasın.',
    description:
      'ERP’nden ürün maliyetini, pazaryerlerinden satış ve kesintileri, e-ticaret altyapından siparişleri, kargo firmalarından gönderi maliyetlerini ZHesap tek yerde bir araya getirir.',
    logos: [
      { name: 'Trendyol', src: 'assets/logos/trendyol.svg' },
      { name: 'Hepsiburada', src: 'assets/logos/hepsiburada.svg' },
      { name: 'ikas', src: 'assets/logos/ikas.svg' },
      { name: 'Ticimax', src: 'assets/logos/ticimax.svg' },
      { name: 'T-Soft', src: 'assets/logos/tsoft.svg' },
      { name: 'Shopify', src: 'assets/logos/shopify.svg' },
      { name: 'Nebim', src: 'assets/logos/nebim.png' },
      { name: 'Logo', src: 'assets/logos/logo.svg' },
      // Mikro'nun logo dosyası yok; tasarımdaki gibi kelime marka yazılır.
      { name: 'MİKRO' },
    ] as { name: string; src?: string }[],
    more: { label: '+ daha fazlası', href: routes.entegrasyonlar },
  },
  assemble: {
    eyebrow: 'Tek panel',
    title: 'Tek panel,',
    titleAccent: 'tüm finansal resim.',
    description: 'Her modül kendi ekranıyla; büyüt, incele, ilgili sayfaya geç.',
    frameLabel: 'ZHesap modüllerinin tek panelde birleştiği ekran',
    inspect: 'İncele →',
  },
  products: {
    eyebrow: 'Ürünler',
    title: 'E-ticarette para nerede kazanılıyor, nerede kayboluyor gör.',
    description: 'Tüm operasyonunu tek platformda analiz et, riskleri erken gör, aksiyon al.',
    allCta: { label: 'Tüm Ürünler', href: routes.ozellikler.root },
    explore: 'Keşfet',
    expandLabel: (title: string) => `${title} ekranını büyüt`,
    closeLabel: 'Kapat',
    demoCta: '7 Gün Ücretsiz Dene',
    items: [
      {
        id: 'karlilik',
        title: 'Kârlılık Analizi',
        tagline: 'Gerçek net kârını siparişten ürüne kadar gör.',
        description:
          'Komisyon, kargo, ürün maliyeti ve diğer giderleri hesaba katarak her siparişin gerçek kârlılığını ortaya çıkarır.',
        checks: [
          'Sipariş bazında net kârı hesaplayın',
          'Pazaryeri komisyonlarını analiz edin',
          'Ürün ve kategori bazında kârı karşılaştırın',
          'Kârsız siparişleri tespit edin',
        ],
        href: routes.ozellikler.karlilik,
        accent: '#60a5fa',
        detail: {
          headline: 'Cironuzu değil, gerçek kârınızı görün.',
          intro:
            'Yüksek ciro her zaman yüksek kâr anlamına gelmez. ZHesap; ürün maliyeti, pazaryeri komisyonu, kargo, indirim, reklam ve diğer giderleri birlikte değerlendirerek her siparişin gerçek kârlılığını ortaya çıkarır.',
          bullets: [
            'Sipariş bazında net kârı hesaplayın',
            'Pazaryeri komisyonlarını analiz edin',
            'Kargo ve diğer giderleri hesaba katın',
            'Ürün ve kategori bazında kârı karşılaştırın',
            'Pazaryeri bazında kârlılığı görün',
            'Kârsız siparişleri tespit edin',
          ],
        },
      },
      {
        id: 'finans',
        title: 'Finans & Mutabakat',
        tagline: 'Eksik hakedişleri ve hatalı kargo bedellerini anında yakala.',
        description:
          'Pazaryeri hakedişlerini beklenen tutarla, kargo faturalarını anlaşmalı tarifenle karşılaştırır.',
        href: routes.ozellikler.hakedis,
        accent: '#a78bfa',
        detail: {
          headline: 'Paranızı ne zaman ve ne kadar alacağınızı bilin.',
          intro:
            'Pazaryeri hakedişlerini beklenen tutarla, kargo faturalarını anlaşmalı tarifenizle karşılaştırır. Eksik ödemeleri, desi farklarını ve fazla kesintileri gönderi ve dönem bazında tespit eder.',
          bullets: [
            'Beklenen ve ödenen hakedişi karşılaştırın',
            'Eksik ödemeleri tespit edin',
            'Ödeme tarihlerini takip edin',
            'Desi ve ölçüm farklarını bulun',
            'Fazla kargo kesintilerini yakalayın',
            'Nakit akışınızı doğru planlayın',
          ],
        },
      },
      {
        id: 'kampanya',
        title: 'Kampanya Kârlılığı & Sihirbazı',
        tagline: 'Kârlı kampanyalara otomatik katıl, satışını büyüt.',
        description:
          'Trendyol’un 6 kampanya kurgusu tek ekranda. Kârlı ürünler otomatik katılır, zarar ettirecekler dışarıda kalır.',
        href: routes.ozellikler.kampanya,
        accent: '#fb923c',
        detail: {
          headline: 'Kampanyalarınızı ciroyla değil, kârla ölçün.',
          intro:
            'Bir kampanyanın satış getirmesi, mutlaka para kazandırdığı anlamına gelmez. Kampanya Sihirbazı, Trendyol’un 6 kampanya kurgusunu tek ekranda toplar; her teklifte net kârınızı katılmadan önce hesaplar, kârlı ürünleri kampanyaya otomatik katar, zarar ettirecekleri dışarıda bırakır.',
          bullets: [
            'Trendyol’un 6 kampanya kurgusunu tek ekranda görün',
            'Her teklifte birim ve toplam net kârı önceden görün',
            'Kârlı ürünleri kampanyaya otomatik katın',
            'Zarar ettirecek ürünleri dışarıda bırakın',
            'Katılmadan önce kampanyayı simüle edin',
            'Kampanya bitince ürün bazında sonucu görün',
          ],
        },
      },
      {
        id: 'stok',
        title: 'Stok Zekâsı',
        tagline: 'Kritik, hareketsiz ve tükenmek üzere olan ürünleri bul.',
        description:
          'Satış hızını ve stok seviyesini birlikte okuyarak hangi üründe ne kadar sermaye bağlı olduğunu gösterir.',
        href: routes.ozellikler.stok,
        accent: '#4ade80',
        detail: {
          headline: 'Stoğunuzu değil, sermayenizi yönetin.',
          intro:
            'Stokta duran her ürün aynı zamanda işletmenizin bağlı sermayesidir. ZHesap; satış hızınızı, stok miktarınızı ve ürün devir sürelerinizi analiz ederek hangi ürünlerde fazla veya yetersiz stok bulunduğunu ortaya çıkarır.',
          bullets: [
            'Stokta ne kadar paranın bağlı olduğunu görün',
            'Günlük satış hızını analiz edin',
            'Kritik stok seviyelerini anında görün',
            'Fazla stokları tespit edin',
            'Stokta kaç günlük ürün kaldığını görün',
            'Satış hızına göre stok planlayın',
          ],
        },
      },
      {
        id: 'rakip',
        title: 'Rakip & Sektör Analizi',
        tagline: 'Rakip fiyat, stok, kampanya ve BuyBox hareketlerini izle.',
        description:
          'Kategorideki fiyat aralığında nerede durduğunu ve rakiplerin son hareketlerini gösterir.',
        href: routes.ozellikler.rekabet,
        accent: '#f87171',
        detail: {
          headline: 'Rakiplerinizi ve pazarı birlikte analiz edin.',
          intro:
            'Rakiplerinizin fiyatlarını, ürünlerini ve fiyat değişimlerini takip ederek pazardaki konumunuzu sürekli güncel tutun. ZHesap, ürünlerinizi rakip fiyatlarıyla karşılaştırarak hangi ürünlerde avantajlı, hangilerinde geride olduğunuzu gösterir.',
          bullets: [
            'Rakip ürün fiyatlarını takip edin',
            'Fiyat değişimlerini anlık görün',
            'Kendi fiyatınızı rakiplerle karşılaştırın',
            'Kategori bazında fiyat hareketlerini görün',
            'Rakip kampanya ve indirimlerini izleyin',
            'Fiyatlandırma kararlarını veriye göre alın',
          ],
        },
      },
    ] as LandingProduct[],
    minis: [
      {
        title: 'Akıllı Uyarı Sistemi',
        desc: 'Kâr düşüşünü, hatayı ve fırsatı büyümeden önce anında yakala.',
        icon: 'bell',
        accent: '#fbbf24',
        href: routes.ozellikler.uyari,
      },
      {
        title: 'Z’eki',
        desc: 'Verilerini analiz et, doğru aksiyonu Z’eki’ye sor.',
        icon: 'robot',
        accent: '#f9a8d4',
        href: routes.ozellikler.zeki,
        badge: 'Beta',
      },
      {
        title: 'AI Müşteri İlişkileri',
        desc: 'Müşteri sorularını yapay zekâyla yanıtla.',
        icon: 'chat',
        accent: '#a78bfa',
        href: routes.ozellikler.crm,
      },
    ] as { title: string; desc: string; icon: IconName; accent: string; href: string; badge?: string }[],
  },
  /** Hero'nun altındaki gerçek vaka (30 Ekim revizesi). Rakamlar müşteri izniyle; fark = faturalanan − olması gereken. */
  caseStudy: {
    eyebrow: 'Gerçek vaka',
    title: 'Bir müşterimiz 2 ayda',
    amount: '495.618 ₺',
    titleEnd: 'fazla kesilen kargo faturası buldu.',
    description: '27.089 gönderiyi anlaşmasıyla tek tek karşılaştırdık. Fark kargo firmasından tazmin edildi.',
    cta: { label: '7 Gün Ücretsiz Dene', href: '#erken-erisim' },
    offer: 'Denemede son 3 ayının kargo ve hakediş kontrolünü de ücretsiz yapıyoruz.',
    note: 'Vaka müşteri izniyle, isim verilmeden paylaşılıyor. Her firmanın sonucu farklıdır.',
    chartLabel: '2 ayda 27.089 gönderinin kargo faturası',
    expected: { label: 'Anlaşmaya göre olması gereken', value: 3588866 },
    billed: { label: 'Faturalanan', value: 4084484 },
    excess: 'Fazla kesilen',
    perShipment: { label: 'Gönderi başı ortalama fark', value: '~18 ₺' },
  },
  extension: {
    eyebrow: 'Tarayıcı eklentisi',
    title: 'Pazaryeri panelinden çıkmadan',
    titleAccent: 'gerçek kârını gör.',
    description:
      'ZHesap eklentisi satıcı panelinin ana sayfasına, siparişlerine, promosyon ekranlarına ve ürün listene kâr hesabını ekler. Ürün maliyeti, komisyon, kargo, hizmet bedeli, stopaj ve net KDV hesaba katılır.',
    included: 'Tüm paketlerde dahil.',
    cta: { label: 'Eklentiyi incele', href: routes.araclar.chrome },
    /* Banttaki ekran eklenti sayfasının hero ekranıdır (`pages/products/EklentiScreens → OrdersScreen`). */
    note: 'Örnek ekran: temsili ürünler ve rakamlar, kimlik bilgileri gizli. Net KDV etkisi de hesaba katılır.',
  },
  zeki: {
    eyebrow: 'Z’eki',
    badge: 'Beta',
    title: 'İşletmenin en akıllı çalışanı artık beta olarak ZHesap’ta.',
    description: '“Geçen ay neden kârım düştü?” diye sor; nedenini ve alman gereken aksiyonu söylesin.',
    cta: { label: 'Z’eki’yi tanı', href: routes.ozellikler.zeki },
  },
} as const;

/**
 * Ürün kısa kimlikleri: çözüm ve ihtiyaç sayfalarındaki "Bu ihtiyaç için
 * ürünlerimiz" kartları rengini, ikonunu ve adresini buradan okur.
 */
export const productMeta = {
  karlilik: { title: 'Kârlılık Analizi', href: routes.ozellikler.karlilik, color: '#60a5fa', rgb: '59,130,246', icon: 'M5 20V14M10 20V9M15 20V12M20 20V5' },
  finans: { title: 'Finans & Mutabakat', href: routes.ozellikler.hakedis, color: '#a78bfa', rgb: '139,92,246', icon: 'M4 6h16v4H4zM4 14h16v4H4z' },
  kampanya: { title: 'Kampanya Kârlılığı', href: routes.ozellikler.kampanya, color: '#fb923c', rgb: '249,115,22', icon: 'M19 5L5 19M7.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3M16.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3' },
  stok: { title: 'Stok Zekâsı', href: routes.ozellikler.stok, color: '#4ade80', rgb: '34,197,94', icon: 'M12 3l8 4.5v9L12 21l-8-4.5v-9zM12 12l8-4.5M12 12v9M12 12L4 7.5' },
  rakip: { title: 'Rakip & Sektör Analizi', href: routes.ozellikler.rekabet, color: '#f87171', rgb: '239,68,68', icon: 'M3 17l6-6 4 4 8-8M15 7h6v6' },
  uyari: { title: 'Akıllı Uyarı Sistemi', href: routes.ozellikler.uyari, color: '#fbbf24', rgb: '251,191,36', icon: 'M6 8a6 6 0 1112 0c0 7 3 9 3 9H3s3-2 3-9M10 21h4' },
  ai: { title: 'AI Müşteri İlişkileri', href: routes.ozellikler.crm, color: '#a78bfa', rgb: '139,92,246', icon: 'M4 5h16v11H9l-5 4zM9 10h.01M12 10h.01M15 10h.01' },
  eklenti: { title: 'Tarayıcı Eklentisi', href: routes.araclar.chrome, color: '#45c0ee', rgb: '69,192,238', icon: icons.chrome },
  zeki: { title: 'Z’eki', href: routes.ozellikler.zeki, color: '#f9a8d4', rgb: '244,114,182', icon: icons.robot },
} as const;

export type ProductKey = keyof typeof productMeta;

/**
 * "İhtiyaca göre" çözüm sayfaları. Beşi aynı şablonu kullanır
 * (pages/need): hero'daki "Önce / ZHesap ile" kartı `pains` ile `steps`
 * açıklamaları arasında döner; adım çizelgesi sırayla dolar.
 */
export interface NeedPage {
  href: string;
  /** Hero'daki ikinci renkli blob. */
  blob: string;
  title: string;
  titleAccent: string;
  lead: string;
  pains: string[];
  steps: { title: string; desc: string }[];
  products: { id: ProductKey; desc: string }[];
  quote: string;
  quoteAccent: string;
}

export const needCommon = {
  crumb: 'Çözümler · İhtiyaca göre',
  primaryCta: { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' },
  secondaryCta: { label: 'Nasıl çözer?', href: '#nasil' },
  compareLabel: 'Karşılaştırma',
  before: { tab: 'Önce', title: 'ZHesap’tan önce' },
  after: { tab: 'ZHesap ile', title: 'ZHesap ile' },
  painsTitle: 'Tanıdık geliyor mu?',
  stepsTitle: 'ZHesap bunu nasıl çözer?',
  productsTitle: 'Bu ihtiyaç için ürünlerimiz',
  inspect: 'İncele →',
  cta: {
    title: 'Kendi verinle birlikte bakalım.',
    desc: 'Demo görüşmesinde ihtiyacına özel senaryoyu birlikte kuralım.',
    button: { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' },
  },
} as const;

export const needs: NeedPage[] = [
  {
    href: routes.cozumler.kampanya,
    blob: '#f97316',
    title: 'Kampanyaya girmeden önce',
    titleAccent: 'cebinde ne kalacağını gör.',
    lead: 'İndirim, kupon ve pazaryeri kampanyalarının kârına gerçek etkisini önceden hesapla. Ciroyu değil, net kârı büyüten kampanyalara odaklan.',
    pains: [
      'Kampanya dönemi satışlar artıyor ama ay sonunda hesap tutmuyor.',
      'Teklif gelen her üründe katılmak kârlı mı, bilmiyorsun.',
      'Kampanyanın gerçek getirisini hesaplamak günler sürüyor.',
    ],
    steps: [
      { title: 'Simüle et', desc: 'Kampanya fiyatı ve komisyon indirimiyle birim net kârı önceden gör.' },
      { title: 'Seç', desc: 'Kârlı ürünlerle katıl, zarar ettirecekleri dışarıda bırak.' },
      { title: 'Takip et', desc: 'Kampanya süresince net kârı canlı izle.' },
      { title: 'Ölç', desc: 'Bitince ürün bazlı sonuç raporunu al.' },
    ],
    products: [
      { id: 'kampanya', desc: 'Kampanyaya girmeden önce ne kazanacağını hesapla.' },
      { id: 'karlilik', desc: 'Gerçek net kârını siparişten ürüne kadar gör.' },
      { id: 'uyari', desc: 'Kampanya etkisini ve marj düşüşlerini anında öğren.' },
    ],
    quote: 'İndirim yapmak kolay.',
    quoteAccent: 'Kârlı indirim yapmak ZHesap’la.',
  },
  {
    href: routes.cozumler.karlilik,
    blob: '#3b82f6',
    title: 'Nerede kazanıp nerede',
    titleAccent: 'kaybettiğini gör.',
    lead: 'Sipariş, ürün, kategori ve kanal bazında gerçek net kârını gör. Kâr eden ürünleri büyüt, zarar ettirenleri düzelt ya da bırak.',
    pains: [
      'Ciro büyüdükçe giderler de büyüyor, kâr yerinde sayıyor.',
      'Kâr eden ve zarar ettiren ürünler aynı tabloda kayboluyor.',
      'Komisyon, kargo, iade ve kesintileri elle hesaplamak zaman alıyor.',
    ],
    steps: [
      { title: 'Bağla', desc: 'Pazaryeri, e-ticaret, ERP ve kargo verilerin otomatik gelir.' },
      { title: 'Gör', desc: 'Her siparişin gerçek net kârı hesaplanır.' },
      { title: 'Ayır', desc: 'Kâr eden ve zarar eden ürünleri, kanalları ayrıştır.' },
      { title: 'Aksiyon al', desc: 'Fiyatı, kampanyayı veya kanalı veriyle düzelt.' },
    ],
    products: [
      { id: 'karlilik', desc: 'Gerçek net kârını siparişten ürüne kadar gör.' },
      { id: 'kampanya', desc: 'Kârı eriten kampanyaları tespit et.' },
      { id: 'rakip', desc: 'Kârını koruyan doğru fiyatı bul.' },
    ],
    quote: 'Çok satanı değil,',
    quoteAccent: 'çok kazandıranı büyüt.',
  },
  {
    href: routes.cozumler.kayip,
    blob: '#7c3aed',
    title: 'Eksik hakedişleri ve',
    titleAccent: 'hatalı kesintileri yakala.',
    lead: 'Pazaryerinden alman gereken her kuruşu sipariş bazında kontrol et. Eksik ödenen hakedişleri, fazla kargo kesintilerini ve desi farklarını otomatik tespit et.',
    pains: [
      'Ödenen tutar beklentinin altında ama farkın nereden geldiği belli değil.',
      'Desi ve anlaşma dışı tarifeler fark edilmeden ödeniyor.',
      'Binlerce siparişi tek tek kontrol etmek mümkün değil.',
    ],
    steps: [
      { title: 'Hesapla', desc: 'Her siparişte alman gereken hakediş hesaplanır.' },
      { title: 'Karşılaştır', desc: 'Pazaryeri ödemeleri ve kargo faturalarıyla eşleştirilir.' },
      { title: 'Tespit et', desc: 'Farklar sipariş ve kalem bazında listelenir.' },
      { title: 'Haberdar ol', desc: 'Fark oluştuğu an bildirim alırsın.' },
    ],
    products: [
      { id: 'finans', desc: 'Eksik hakedişleri ve hatalı kargo bedellerini yakala.' },
      { id: 'uyari', desc: 'Farkları oluştuğu an öğren.' },
      { id: 'karlilik', desc: 'Kesintilerin kârına gerçek etkisini gör.' },
    ],
    quote: 'Kazandığın parayı',
    quoteAccent: 'kaybetmeden önce koru.',
  },
  {
    href: routes.cozumler.stok,
    blob: '#22c55e',
    title: 'Paran hangi üründe bekliyor,',
    titleAccent: 'hangisi tükeniyor gör.',
    lead: 'Satış hızı ve stok seviyeni birlikte analiz et. Tükenmeden önce sipariş ver, satmayan stoktaki sermayeyi serbest bırak.',
    pains: [
      'Stok tükendiğinde satış ve sıralama kaybı yaşanıyor.',
      'Satmayan ürünlerde ciddi sermaye bekliyor.',
      'Tedarik zamanlaması tahminle yapılıyor.',
    ],
    steps: [
      { title: 'Analiz et', desc: 'Satış hızı ve stok seviyesi birlikte değerlendirilir.' },
      { title: 'Önceden gör', desc: '15, 30, 60 günde tükenecek ürünler listelenir.' },
      { title: 'Sermayeyi bul', desc: 'Hareketsiz ürünlerde bağlı sermaye hesaplanır.' },
      { title: 'Aksiyon al', desc: 'Sipariş, kampanya veya tasfiye kararını veriyle ver.' },
    ],
    products: [
      { id: 'stok', desc: 'Kritik, hareketsiz ve tükenmek üzere olan ürünleri bul.' },
      { id: 'kampanya', desc: 'Hareketsiz stoğu kârlı kampanyayla erit.' },
      { id: 'uyari', desc: 'Kritik stok seviyesinde anında uyarı al.' },
    ],
    quote: 'Doğru ürün, doğru stok,',
    quoteAccent: 'doğru zamanda.',
  },
  {
    href: routes.cozumler.rakip,
    blob: '#ef4444',
    title: 'Fiyat, stok, kampanya ve',
    titleAccent: 'BuyBox hareketlerini izle.',
    lead: 'Rakiplerinin her hamlesini kendi ürünlerinle yan yana gör. BuyBox’ı kaybettiğinde nedenini ve kârlı kalarak ne yapman gerektiğini öğren.',
    pains: [
      'Rakip fiyat düşürdüğünde satışların sessizce kayıyor.',
      'Rakip sayfalarını tek tek gezmek saatler alıyor.',
      'Rakibi takip ederken kârını eritiyorsun.',
    ],
    steps: [
      { title: 'Rakiplerini seç', desc: 'Takip etmek istediğin rakip ve ürünleri tanımla.' },
      { title: 'İzle', desc: 'Fiyat, stok, kampanya ve BuyBox değişimleri otomatik takip edilir.' },
      { title: 'Haberdar ol', desc: 'Önemli hareketlerde anında bildirim alırsın.' },
      { title: 'Kârlı karar ver', desc: 'Kârını koruyan doğru fiyatı gör.' },
    ],
    products: [
      { id: 'rakip', desc: 'Rakip fiyat, stok, kampanya ve BuyBox hareketlerini izle.' },
      { id: 'karlilik', desc: 'Fiyat değişiminin kârına etkisini gör.' },
      { id: 'uyari', desc: 'Rakip hareketlerinden anında haberdar ol.' },
    ],
    quote: 'Rakibini izle,',
    quoteAccent: 'kârını koru.',
  },
];

/**
 * "Satış kanalına göre" çözüm sayfaları. Her biri kendi tasarımıyla gelir
 * (pages/solutions/*); burada yalnız metinleri durur. Canlı görsellerin
 * örnek verisi ilgili sayfa dosyasındadır.
 */
const channelCrumb = 'Çözümler · Satış kanalına göre';
const demoCta = { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' };
const integrationsCta = { label: 'Entegrasyonları Gör', href: routes.entegrasyonlar };

export const solutions = {
  pazaryeri: {
    hero: {
      crumb: channelCrumb,
      title: 'Tüm pazaryeri operasyonunu',
      titleAccent: 'tek merkezden yönet.',
      lead: 'Trendyol, Hepsiburada ve diğer pazaryerlerindeki mağazalarını tek panelde birleştir. Komisyon, kargo, hizmet bedeli ve stopaj düşüldükten sonra her siparişte gerçekte ne kazandığını gör.',
      primary: demoCta,
      secondary: integrationsCta,
    },
    profit: {
      kicker: 'Kârlılık',
      title: 'Her siparişin gerçek net kârı',
      lead: 'Pazaryeri paneli ciroyu gösterir, ZHesap kârı. Ürün maliyeti, komisyon, kargo, hizmet bedeli, stopaj ve iadeler sipariş bazında düşülür.',
      checks: [
        'Sipariş, ürün, kategori ve mağaza bazında net kâr',
        'Zararına satılan ürünler anında görünür',
        'Tüm pazaryerleri aynı mantıkla, yan yana',
      ],
    },
    settlement: {
      kicker: 'Finans & Mutabakat',
      title: 'Eksik hakedişi ve hatalı kesintiyi yakala',
      lead: 'Her siparişte alman gereken hakedişi hesaplar, pazaryerinin ödemesiyle karşılaştırır. Fark varsa sipariş bazında listeler.',
      checks: [
        'Beklenen ve yatan hakediş karşılaştırması',
        'Desi ve kargo kesintisi kontrolü',
        'Fark oluştuğunda anında bildirim',
      ],
    },
    campaign: {
      kicker: 'Kampanya Kârlılığı',
      title: 'Kampanyaya girmeden önce ne kazanacağını bil',
      lead: 'Pazaryeri kampanya tekliflerini ürün bazında simüle et; hangi üründe katılmanın kârlı olduğunu önceden gör.',
      checks: [
        'Kampanya fiyatında birim net kâr',
        'Komisyon indirimi dahil gerçek hesap',
        'Zarar ettirecek ürünler için uyarı',
      ],
    },
    more: {
      title: 'Pazaryeri satıcısı için hepsi bir arada',
      desc: 'Tek panelden yönetebileceğin diğer ürünler.',
      items: [
        { id: 'stok', desc: 'Kritik, hareketsiz ve tükenmek üzere olan ürünleri bul.' },
        { id: 'rakip', desc: 'Rakip fiyat, stok, kampanya ve BuyBox hareketlerini izle.' },
        { id: 'ai', desc: 'Müşteri sorularını yapay zekâyla yanıtla.' },
        { id: 'uyari', desc: 'Kârını etkileyen her gelişmeyi büyümeden yakala.' },
      ] as { id: ProductKey; desc: string }[],
    },
    quote: { text: 'Pazaryerinde ciro herkesin önünde.', accent: 'Gerçek kâr ZHesap’ta.' },
    cta: {
      title: 'Pazaryeri mağazalarının gerçek kârını gör.',
      desc: 'Mağazalarını bağla, yaklaşık 15 dakikada ilk kârlılık raporun hazır.',
      button: demoCta,
    },
  },
  eticaret: {
    hero: {
      crumb: channelCrumb,
      title: 'Satış, maliyet ve kârlılığını',
      titleAccent: 'tek yerde birleştir.',
      lead: 'Kendi e-ticaret sitenden gelen siparişleri ürün maliyeti, sanal POS komisyonu, kargo, kupon ve iadelerle birlikte hesapla. Sitende gerçekte ne kazandığını sipariş bazında gör.',
      primary: demoCta,
      secondary: integrationsCta,
    },
    platforms: {
      title: 'Kullandığın altyapıyla çalışır',
      desc: 'E-ticaret siteni birkaç adımda bağla, veriler otomatik aksın.',
    },
    profit: {
      kicker: 'Kârlılık',
      title: 'Sitendeki her siparişin gerçek kârı',
      lead: 'Web sitesi siparişlerinde gözden kaçan maliyetleri, yani sanal POS komisyonu, kargo, kupon ve iadeleri sipariş bazında düşer, net kârını hesaplar.',
      checks: [
        'Sanal POS komisyonu dahil gerçek maliyet',
        'Kupon ve indirimlerin kâra etkisi',
        'İade ve iptallerin net etkisi',
      ],
    },
    channels: {
      kicker: 'Kanal karşılaştırması',
      title: 'Siten mi, pazaryeri mi daha kârlı?',
      lead: 'Aynı ürünün web sitende ve pazaryerlerinde ne kadar kazandırdığını yan yana gör; reklam ve kampanya bütçeni en kârlı kanala yönlendir.',
      checks: [
        'Ürün bazında kanal karşılaştırması',
        'Kanal bazında marj ve net kâr',
        'Kârlı kanala odaklanmak için net veri',
      ],
    },
    quote: { text: 'Siten senin vitrinin.', accent: 'Kârın da sende kalsın.' },
    cta: {
      title: 'Web sitenin gerçek kârını gör.',
      desc: 'Altyapını bağla, yaklaşık 15 dakikada ilk kârlılık raporun hazır.',
      button: demoCta,
    },
  },
  cokluMarka: {
    hero: {
      crumb: channelCrumb,
      title: 'Tüm mağazalarını',
      titleAccent: 'konsolide olarak takip et.',
      lead: 'Birden fazla marka ve mağazayı tek panelde birleştir. Toplam tabloyu tek bakışta gör, istediğin an marka, mağaza ve kanal bazında detaya in.',
      primary: demoCta,
    },
    consolidated: {
      kicker: 'Konsolide rapor',
      title: 'Tek tablo, tüm markalar',
      lead: 'Tüm markalarının ve mağazalarının ciro, net kâr ve marjını konsolide olarak gör; hangi markanın büyüttüğünü, hangisinin kârını erittiğini anında fark et.',
      checks: [
        'Marka, mağaza ve kanal bazında konsolide rapor',
        'Markalar arası marj karşılaştırması',
        'Aynı şirket altındaki sınırsız mağaza',
      ],
    },
    roles: {
      kicker: 'Yetkilendirme',
      title: 'Herkes kendi alanını görsün',
      lead: 'Ekibine marka ve ekran bazında yetki ver. Finans tüm tabloyu görürken marka yöneticisi yalnızca kendi mağazalarına odaklansın.',
      checks: [
        'Rol ve marka bazında yetkilendirme',
        'Her kullanıcı aynı anda tek oturumla güvenli erişim',
        'İhtiyaca göre ek kullanıcı tanımlama',
      ],
    },
    enterprise: {
      title: 'Farklı şirketler altında birden fazla markan mı var?',
      desc: 'Farklı tüzel kişiliklere ait markalar ve aylık 15.000+ sipariş hacmi için sana özel kurumsal yapı ve teklif hazırlıyoruz.',
      cta: { label: 'Kurumsal Teklif Al', href: routes.iletisim },
    },
    quote: { text: 'Mağaza sayın arttıkça karmaşa değil,', accent: 'netlik artsın.' },
    cta: {
      title: 'Tüm markalarını tek panelde gör.',
      desc: 'Demo görüşmesinde yapına uygun konsolide görünümü birlikte kuralım.',
      button: demoCta,
    },
  },
  omnichannel: {
    hero: {
      crumb: 'Çok yakında',
      title: 'Mağaza, e-ticaret ve pazaryeri',
      titleAccent: 'tek tabloda.',
      lead: 'Fiziksel mağazalarını, e-ticaret siteni ve pazaryeri mağazalarını tek panelde birleştiren omnichannel çözümümüz çok yakında. Tüm kanallarda gerçekte ne kazandığını tek yerden gör.',
    },
    waitlist: {
      label: 'E-posta adresin',
      placeholder: 'ornek@sirket.com',
      submit: 'Haber Ver',
      submitting: 'Gönderiliyor…',
      hint: 'Yayına çıktığında ilk sen haberdar ol.',
      invalid: 'Geçerli bir e-posta adresi girin.',
      success: 'Kaydın alındı. Omnichannel çözümümüz yayına çıktığında ilk sen haberdar olacaksın.',
      error: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    },
    chips: [
      'Tüm kanallarda tek kârlılık tablosu',
      'Kanallar arası stok görünürlüğü',
      'Mağaza bazında performans',
    ],
    features: [
      { icon: 'M4 10v10h16V10M3 6l2-3h14l2 3v2a3 3 0 01-6 0 3 3 0 01-6 0 3 3 0 01-6 0z', title: 'Fiziksel mağaza dahil', desc: 'Mağaza satışların online kanallarınla aynı tabloda.' },
      { icon: 'M5 20V14M10 20V9M15 20V12M20 20V5', title: 'Kanallar arası karşılaştırma', desc: 'Aynı ürünün hangi kanalda daha kârlı olduğunu gör.' },
      { icon: 'M12 3l8 4.5v9L12 21l-8-4.5v-9zM12 12l8-4.5M12 12v9M12 12L4 7.5', title: 'Bütünleşik stok', desc: 'Tüm kanallardaki stoğunu tek yerden izle.' },
    ],
    cta: {
      title: 'Beklerken ZHesap’ı keşfet.',
      desc: 'Kârlılık, finans ve stok modüllerimiz bugün kullanıma hazır.',
      button: demoCta,
    },
  },
} as const;
